/**
 * Shared constants for group booking features.
 *
 * These defaults are used when server settings are not yet configured
 * or when initializing empty states.
 */

import type { HotelInfo, DiscountTier, EmailTemplate } from "./types";

// Room allocation constants
export const DEFAULT_ROOM_RATE = 200;
export const MAX_ROOMS_PER_BOOKING = 100;

export const DEFAULT_HOTEL_INFO: HotelInfo = {
  hotelName: "",
  contactName: "",
  contactEmail: "",
  contactPhone: "",
  tagline: "",
  keyAmenities: [],
};

export const DEFAULT_DISCOUNT_TIERS: DiscountTier[] = [
  { maxOccupancy: 80, discountPercent: 20 },
  { maxOccupancy: 100, discountPercent: 10 },
];

export const DEFAULT_EMAIL_TEMPLATE: EmailTemplate = {
  greeting: "Dear [Guest Name],",
  introduction:
    "Thank you for considering [Hotel Name] for your upcoming group stay. We are delighted to present you with a customized quote based on your requirements.",
  closing:
    "Please don't hesitate to reach out if you have any questions or would like to discuss alternative arrangements. We look forward to welcoming your group!",
  signature: "Best regards,\n[Contact Name]\n[Hotel Name]",
};
